import React, { useContext, useEffect } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

import { GlobalContext } from "../../app/providers/GlobalState";

const ConteudoResumo = props => {
    const context = useContext(GlobalContext);
    const { modulo, aula } = JSON.parse(localStorage.getItem("questionario_" + localStorage.getItem("codigo_aula")));

    const calcularNotaFinal = () => {
        axios({
            method: "put",
            url: "/api/turma/atualizar-media-avaliacao",
            params: {
                moduloId: localStorage.getItem("codigo_aula")
            }
        })
            .then(response => {
                console.log("Nota final calculada com sucesso");
            })
            .catch(error => {
                console.log(error);
            });
    };

    useEffect(() => {
        calcularNotaFinal();
    }, []);

    return (
        <div className="container">
            <div className="bloco-resumo">
                <div className="resumo">
                    <div className="header">
                        <i className="fas fa-check-circle" />
                        <span className="titulo">Parabéns!</span>
                        <span className="descricao">Avaliação concluída</span>
                    </div>
                    <div className="apresentacao">
                        <span className="nome-modulo">{modulo}</span>
                        <span className="aula">{aula}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(ConteudoResumo);
